import { LabelValue, FormGrid, IBatch, Widget } from '../../../shared';
import { FC } from 'react';
import { ListAltTwoTone } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface Props {
    batch: IBatch;
}

export const BatchDetail: FC<Props> = ({ batch }) => {
    const { t } = useTranslation();
    return (
        <Widget title={t('batch')} icon={<ListAltTwoTone color="primary" />}>
            <FormGrid size={{ xs: 3 }} containerProps={{ spacing: 1 }}>
                <LabelValue label={t('date')} value={batch.date} />
                <LabelValue label={t('supplier')} value={batch.supplier.name} />
                <LabelValue label={t('referenceNumber')} value={batch?.referenceNumber} />
                <LabelValue label={t('qrCode')} value={batch?.qrCode?.name} />
            </FormGrid>
        </Widget>
    );
};
